import { styled } from '@mui/material';
import { ReactNode } from 'react';

import { Step } from './components/Step';

const StyledContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  marginBottom: 32,
});

export type StepperProps = {
  children: ReactNode;
};

export const Stepper = ({ children }: StepperProps) => {
  return <StyledContainer>{children}</StyledContainer>;
};

Stepper.Step = Step;
